import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import { VALIDAR_STOCK } from '../../../common/types/parametroType'
import CustomTable from '../../../components/CustomTable';
import auth from '../../../common/utility/auth';

export default function ResultList(props) {
    const validarStock = auth.user().parametros.filter(m => m.abreviatura === VALIDAR_STOCK)[0].valor === "1" ? true : false;
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Editar"}>
                                <Button
                                    disabled={!row.flag}
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Detalle de Precios"}>
                                <Button
                                    disabled={!row.flag}
                                    type="primary"
                                    icon="read"
                                    size={"small"}
                                    onClick={() => props.onDetail(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Replicar Precios"}>
                                <Button
                                    disabled={!row.flag}
                                    type="primary"
                                    icon="interaction"
                                    size={"small"}
                                    onClick={() => props.onReplicar(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={row.flag ? "Deshabilitar" : "Activar"}>
                                <Button
                                    type={row.flag ? "danger" : "success"}
                                    icon={row.flag ? "close" : "check"}
                                    size={"small"}
                                    onClick={() => props.onDeleteActive(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Carga Masiva"}>
                                <Button
                                    disabled={!row.flag}
                                    type="success"
                                    icon="file-excel"
                                    size={"small"}
                                    onClick={() => props.onFile(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title={"Exportar Excel"}>
                                <Button
                                    disabled={!row.flag}
                                    loading={props.loadingdetalleExcel}
                                    type="primary"
                                    icon="download"
                                    size={"small"}
                                    onClick={() => props.onExportDetail(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Nombre',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true
                },
                {
                    title: 'Establecimiento',
                    dataIndex: 'nombreEstablecimiento',
                    key: 'nombreEstablecimiento',
                    sorter: true
                },
                (validarStock ?
                    {
                        title: 'Tipo Lista de Precio',
                        dataIndex: 'nombreTipoListaPrecio',
                        key: 'nombreTipoListaPrecio',
                        sorter: true
                    }
                    : {}),
                {
                    title: 'Estado',
                    dataIndex: 'flag',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    render: (value) => {
                        return (<div className="custom-options" >
                            <Tag color={value ? "green" : "red"}>{value ? "Activo" : "Inactivo"}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}